import React from 'react';

import { EditableDataListView } from './editable-data-list-view';

type DataListViewProps = {
  data: {
    title: string;
    value: React.ReactNode | string | number;
  }[];
  /** Optional fixed width for the label column. When omitted, the column auto-sizes to the widest label. */
  labelWidth?: number | string;
};

export const DataListView: React.FC<DataListViewProps> = ({
  data,
  labelWidth,
}) => <EditableDataListView data={data} labelWidth={labelWidth} />;
